import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { AppSettings } from '../../app.config';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class HeaderService {
  private apiUrl = AppSettings.DRI_ENDPOINT;
  initial: boolean;
  constructor(private http: Http) {
  }

  getState(input): boolean {
    this.initial = input;
    return this.initial;
  }
  logout(): Promise<any> {
    return this.http.get(AppSettings.API_ENDPOINT + 'logout/')
      .toPromise()
      .then(this.handleData)
      .catch(this.handleError)

  }
  private handleData(res: any) {
    let body = res.json();
    return body || {};
  }
  private handleError(error: any): Promise<any> {
    const body = error.json();
    return Promise.reject(body || error);
  }

  public getApiUrl() {
    return this.apiUrl + ' ';
  }
}